import { Injectable } from '@angular/core';
import { AuditLogFilterModel, AuditLogResponseModel } from '@core/models';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  constructor(private readonly apiService: ApiService) {}

  listAuditLog(filter: AuditLogFilterModel): Observable<AuditLogResponseModel> {
    return this.apiService.get('/partners/audit-log/', filter as Record<string, unknown>);
  }
}
